import { render, staticRenderFns } from "./JLjh.vue?vue&type=template&id=87cd9b28&scoped=true"
import script from "./JLjh.vue?vue&type=script&lang=js"
export * from "./JLjh.vue?vue&type=script&lang=js"
import style0 from "./JLjh.vue?vue&type=style&index=0&id=87cd9b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cd9b28",
  null
  
)

export default component.exports